import "./Loader.css";

const Loader = () => {
  return (
    <div className="loader-wrapper">
      <div className="wave-loader">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  );
};

export default Loader;
